import React, { useState } from "react";
import InspectionList from "./inspectionTableList";
import InspectionArchive from "./inspectionArchive";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Colors from "../../Global/colors";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import MiddleHeader from "../middleHeader/middleHeader";
import GlobalApi from "../../Global";
import { Redirect } from "react-router";
import {useTranslation} from 'react-i18next';

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor:'#1a73e8'
    // display:'none'
  },
})(Tabs);



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
  },
  indicator: {
    backgroundColor: "#37baef",
  },
}));

export default function SimpleTabs(props) {
  const {t} = useTranslation();
    let history = useHistory();
  const [packageDetails, setPackageDetails] = useState({});


React.useEffect(() => {
  getPackageDetails()
  if (window.location.pathname == "/inspection") {
    setValue(0);
  } else if (window.location.pathname == "/inspection/archive") {
    setValue(1);
  } 
}, []);

const getPackageDetails = async () => {
  let localstorage = localStorage.getItem("UserData");
  var data = JSON.parse(localstorage);
  let token = data?.token;
  if (data == undefined) {
    return <Redirect to={"/signin"} />;
  }
  let package_inquiry = {
    user_id: data.user_id,
    organization_id: data.organization_id,
  };

  let query = Object.keys(package_inquiry)
    .map(
      (k) =>
        encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
    )
    .join("&");
  let req = await fetch(
    GlobalApi + "/Package/get_user_license_details?" + query,
    {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }
  );

  let reqJson = await req.json();


  if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
    history.replace("/billing");
  } else {
    setPackageDetails(reqJson.package);
  }
};


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  }
  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (data.token == null) {
    return <Redirect to={"/signin"} />;
  }
  return (
    <div style={{ width: "100%", padding: "0px" }}>
       <MiddleHeader />
      <div
        className=""
        style={{
          overflow: "auto",
          width: "100%",
          padding: "20px 30px",
          backgroundColor: Colors.globalColor9,
        }}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          className="scrollHidden shadow"
          style={{
            backgroundColor: "white",
            padding: "0px",
            borderRadius: "5px",
            marginTop: "0px",
            overflowY: "hidden",
          }}
        >
         
         <Grid
              item
              xs={12}
              md={12}
              lg={12}
              style={{
                padding: "5px 20px 0px",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: Colors.globalColor4,
              }}
            >
              <Grid
                container
                justify="space-between"
                alignItems="center"
              >
                <Grid item xs={12} md={12} lg={8}>
                  {/* For Web */}
              {window.innerWidth > 500 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }} label={t("My Inspections")} {...a11yProps(0)} component={Link} to="/inspection" />
                  {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") && <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontWeight: "bold", fontSize: 12, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black" }} label={t("Archives")} {...a11yProps(1)} component={Link} to="/inspection/archive" />}
                </AntTabs>}

                  {/* For Mobile */}
              {window.innerWidth <= 500 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 10, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }} label={t("My Inspections")} {...a11yProps(0)} component={Link} to="/inspection" />
                  {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") && <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontWeight: "bold", fontSize: 10, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black" }} label={t("Archives")} {...a11yProps(1)} component={Link} to="/inspection/archive" />}
                </AntTabs>}
                </Grid>
            
              </Grid>
            </Grid>
            {/* <AppBar position="static">
              <AntTabs
                // className={classes.indicator}
                value={value}
                onChange={handleChange}
              >
                <Tab
                  label="Inspection"
                  {...a11yProps(0)}
                  component={Link}
                  to="/inspection"
                />
                <Tab
                  label="Archive"
                  {...a11yProps(1)}
                  component={Link}
                  to="/inspection/archive"
                />
              </AntTabs>
            </AppBar> */}
            <Switch>
              <Route exact path="/inspection/" component={InspectionList} />
              {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") &&  <Route
                exact
                path="/inspection/archive"
                component={InspectionArchive}
              />}
              {/* <Route
          exact
          path="/inspection/archive/"
          component={InspectionArchive}
        /> */}
            </Switch>
         
        </Grid>
      </div>
    </div>
  );
}
